import { useAuth0 } from "@auth0/auth0-react";
import { ProfileForm } from "../components/ProfileForm";
import { Navigate, useParams } from "react-router-dom";

export const Welcome: React.FC = () => {
  const { isAuthenticated } = useAuth0();
  const params = useParams();

  // Check for specific parameters
  if (params?.code && params?.state && isAuthenticated) {
    // Handle authentication callback
    return <Navigate to="/welcome" replace />;
  }
  
  return (
    <>
      {/* React 19 built-in metadata */}
      <title>Welcome - ACTT Study</title>
      <meta name="description" content="Welcome to ACTT Study. Complete your profile to start contributing to mosquito surveillance research." />
      <meta property="og:title" content="Welcome - ACTT Study" />
      <link rel="canonical" href="https://acttstudy.org/welcome" />

      <div className="App">
        <div style={{ padding: 20 }}>
          <img src="/logo.png" alt="ACTT Logo" style={{ maxWidth: 200 }} />
          <h2>Welcome to ACTT Study</h2>
          <ProfileForm />
        </div>
      </div>
    </>
  );
};

export default Welcome;
